/* __next_internal_client_entry_do_not_use__ LoggedInLoginSection auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLanguage } from "@faire/retailer-visitor-shared/hooks/retailer/useLanguage";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import React, { Suspense } from "react";
import { HeaderNotificationsDropdown } from "../../HeaderNotifications/HeaderNotificationsDropdown";
import { HeaderLine } from "../../styled";
import { HeaderAccountDropdown } from "../HeaderAccountDropdown";
import { LazyHeaderLanguageSelector } from "../HeaderLanguageSelector/LazyHeaderLanguageSelector";
export var LoggedInLoginSection = function() {
    var showLanguageSelector = useLanguage().showLanguageSelector;
    var _useUserStore = useUserStore([
        "browserLevelLanguage",
        "browserLevelLocaleKey"
    ]), browserLevelLanguage = _useUserStore.browserLevelLanguage, browserLevelLocaleKey = _useUserStore.browserLevelLocaleKey;
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = (_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showLanguageSelector ? /*#__PURE__*/ _jsx(LanguageSelectorSection, {
                eventKey: "logged-in-top",
                browserLanguage: browserLevelLanguage,
                browserLocale: browserLevelLocaleKey,
                availableLocales: availableLanguageSelectorLocales,
                assignLocalizedUrl: true
            }) : null,
            /*#__PURE__*/ _jsx(HeaderNotificationsDropdown, {}),
            /*#__PURE__*/ _jsx(HeaderAccountDropdown, {})
        ]
    });
};
var LanguageSelectorSection = function(props) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyHeaderLanguageSelector, _object_spread({}, props))
            }),
            /*#__PURE__*/ _jsx(HeaderLine, {})
        ]
    });
};
